// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"
import type { DataType, FetchType, Filter, FilterType } from "../../types"

// Utils
import { useApi } from "utils"

// Types
interface PaginationType {
  page: number
  pages: number
  size: number
  total: number
}
interface Type extends Filter {
  data: DataType[] 
  isLoading: boolean
  pagination: PaginationType
}

export function useList(): Type {
  // Vars
  const defaultFilter: FilterType = {
    buy: false,
    inventory: false,
    page: 1,
    keyword: "",
    isBuild: false
  }

  // Hooks
  const api = useApi()
  const [data, setData] = useState<DataType[]>([])
  const [isLoading, setLoading] = useState<boolean>(false)
  const [filter, setFilter] = useState<FilterType>(defaultFilter)
  const [pagination, setPagination] = useState<PaginationType>({
    page: 1,
    pages: 0,
    size: 0,
    total: 0
  })

  useEffect(() => {
    setLoading(true)

    api.get(
      "/requestform/getproduct",
      { params: filter }
    ).then((res: SuccessFetch<{
      payload: FetchType[]
      pagination_data: PaginationType
    }>) => {
      const formattedData = res.data.payload.map((item: FetchType) => ({
        ...item,
        available: parseFloat(item.available),
        back_order: parseFloat(item.back_order),
        commited: parseFloat(item.commited),
        mr_unit_name: item.mr_unit_name || "-",
        soh: parseFloat(item.soh)
      }))

      setData(formattedData)
      setPagination(res.data.pagination_data)
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setData([])
      setLoading(false)
      setPagination({
        page: 1,
        pages: 0,
        size: 0,
        total: 0
      })
    }

    // eslint-disable-next-line
  }, [filter])

  const handleCheckbox = (field: "buy" | "inventory" | "isBuild"): void => {
    setFilter(prev => ({
      ...prev,
      [field]: !prev[field],
      page: 1
    }))
  }
  const handlePage = (page: number): void => {
    setFilter(prev => ({
      ...prev,
      page
    }))
  }
  const handleSearch = (value: string): void => {
    setFilter(prev => ({
      ...prev,
      keyword: value,
      page: 1
    }))
  }
  const reset = (): void => {
    setFilter(defaultFilter)
  }

  return {
    filter,
    data,
    isLoading,
    pagination,
    handleCheckbox,
    handlePage,
    handleSearch,
    reset
  }
}